export function shuffleArray(array, currentSongIndex) {
  // remove current song from array
  const currentSong = array.splice(currentSongIndex, 1)[0];

  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  // devide song array into two parts from current song index
  const firstPart = array.slice(0, currentSongIndex);
  const secondPart = array.slice(currentSongIndex);
  // cobined them with current song in the middle
  array = [...firstPart, currentSong, ...secondPart];

  return array;
}

let songs = [];
let currentSongIndex = 0;

export function playNextSong() {
  let nextSongIndex = (currentSongIndex + 1) % songs.length;
  while (songs[nextSongIndex].ignore) {
    nextSongIndex = (nextSongIndex + 1) % songs.length;
  }
  currentSongIndex = nextSongIndex;
  playSong(currentSongIndex);
}

export function playPreviousSong() {
  let previousSongIndex = (currentSongIndex - 1 + songs.length) % songs.length;
  while (songs[previousSongIndex].ignore) {
    previousSongIndex = (previousSongIndex - 1 + songs.length) % songs.length;
  }
  currentSongIndex = previousSongIndex;
  playSong(currentSongIndex);
}

function playSong(index) {
  console.log(`Playing ${songs[index].title} with id ${songs[index].id}`);
}

export const getIngoreSongIds = (playlists) => {
  const ignoreSongs = [];
  playlists.forEach((playlist) => {
    playlist.songs.forEach((song) => {
      if (song.ignore) ignoreSongs.push(song.id + playlist.id);
    });
  });
  return ignoreSongs;
};
